import * as actionTypes from './actionTypes';
import API from '../../axios/api';
import { toastr } from 'react-redux-toastr'
import axios from 'axios';
import { i18n } from '../../translate/i18n';

let CancelToken = axios.CancelToken;
let fetchCompanies_cancel;
let fetchCompaniesById_cancel;
let fetchCompaniesExport_cancel;

export const fetchCompaniesSuccess = (companies) => {
  return {
    type: actionTypes.FETCH_COMPANIES_SUCCESS,
    companies: companies
  };
};

export const setCompaniesFilter = (page, limit, searchText, order, orderBy) => {
  return {
    type: actionTypes.SET_COMPANIES_FILTER,
    companiesFilter: {
      page, limit, searchText, order, orderBy,
    }
  };
};

export const fetchCompaniesInfiniteScrollSuccess = (companies) => {
  return {
    type: actionTypes.FETCH_COMPANIES_INFINITE_SCROLL_SUCCESS,
    companies: companies
  };
};

export const fetchCompanyByIdSuccess = (company) => {
  return {
    type: actionTypes.FETCH_COMPANIES_BY_ID_SUCCESS,
    company: company
  };
}

export const requestCompaniesFail = (error) => {
  return {
    type: actionTypes.REQUEST_COMPANIES_FAIL,
    error: error
  };
};

export const requestCompaniesStart = () => {
  return {
    type: actionTypes.REQUEST_COMPANIES_START
  };
};

export const requestCompaniesInfiniteScrollStart = () => {
  return {
    type: actionTypes.REQUEST_COMPANIES_INFINITE_SCROLL_START
  };
};

export const deleteCompaniesSuccess = (company) => {
  return {
    type: actionTypes.DELETE_COMPANIES_SUCCESS,
    company: company
  }
}

export const checkDeleteDocumentCompaniesSuccess = (checkDelete) => {
  return {
    type: actionTypes.CHECK_DELETE_COMPANIES_SUCCESS,
    checkDelete: checkDelete
  }
}


export const updateCompaniesSuccess = (company) => {
  return {
    type: actionTypes.UPDATE_COMPANIES_SUCCESS,
    company: company
  }
}

export const postCompaniesSuccess = (company) => {
  return {
    type: actionTypes.POST_COMPANIES_SUCCESS,
    company: company
  }
}

export const fetchCompanies = (page, limit, search, order, orderBy) => {
  fetchCompanies_cancel && fetchCompanies_cancel()

  return dispatch => {
    dispatch(requestCompaniesStart());
    dispatch(setCompaniesFilter(page, limit, search, order, orderBy));
    const queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&q=${search ? search : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}`;
    API.get('/companies' + queryParams, {
      cancelToken: new CancelToken(function executor(c) {
        fetchCompanies_cancel = c;
      })
    })
      .then(res => {
        dispatch(fetchCompaniesSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestCompaniesFail(err));
      });
  };
};

export const fetchCompaniesById = (id) => {
  fetchCompaniesById_cancel && fetchCompaniesById_cancel()

  return dispatch => {
    dispatch(requestCompaniesStart());
    API.get('/companies/' + id, {
      cancelToken: new CancelToken(function executor(c) {
        fetchCompaniesById_cancel = c;
      })
    })
      .then(res => {
        dispatch(fetchCompanyByIdSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestCompaniesFail(err));
      });
  };
};

export const deleteCompanies = (index, page, limit, search, order, orderBy) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestCompaniesStart());
      API.put('/companies/' + index + '/delete')
        .then(res => {
          dispatch(deleteCompaniesSuccess(res.data));
          toastr.success(i18n.t('deleteCompaniesStr.toastr'), `${res.data.name} ${i18n.t('deleteCompaniesStr.toastr1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestCompaniesFail(err));
          toastr.error('Erro', err.response.data.message)
          resolve('error');
        });
    })
  }
}

export const postCompanies = (body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(requestCompaniesStart());
      API.post('/companies', body)
        .then(res => {
          dispatch(postCompaniesSuccess(res.data));
          toastr.success(i18n.t('postCompaniesStr.toastr'), `${res.data.name} ${i18n.t('postCompaniesStr.toastr1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestCompaniesFail(err));
          if (err.response.data.message === "Already in use") {
            toastr.error(i18n.t('postCompaniesStr.toastrError'), i18n.t('postCompaniesStr.toastrError1'))
          } else {
            toastr.error('Erro', err.response.data.message)
          }
          resolve('error');
        });
    })

  }
}

export const updateCompanies = (index, body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(requestCompaniesStart());
      API.put('/companies/' + index, body)
        .then(res => {
          dispatch(updateCompaniesSuccess(res.data));
          toastr.success(i18n.t('updateCompaniesStr.toastr'), `${res.data.name} ${i18n.t('updateCompaniesStr.toastr1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestCompaniesFail(err));
          if (err.response.data.message === "Already in use") {
            toastr.error(i18n.t('updateCompaniesStr.toastrError'), i18n.t('updateCompaniesStr.toastrError1'))
          } else {
            toastr.error('Erro', err.response.data.message)
          }
          resolve('error');
        });
    })

  }
}

export const checkDeleteCompanies = (index) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestCompaniesStart());
      API.get('/companies/' + index + '/checkdelete')
        .then(res => {
          dispatch(checkDeleteDocumentCompaniesSuccess(res.data));
          resolve(res.data);
        })
        .catch(err => {
          dispatch(requestCompaniesFail(err));
          resolve('error');
        });
    })
  }
}

export const postAddDocumentCompanies = (index, body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestCompaniesStart());
      API.post('/companies/' + index + '/adddocument', body)
        .then(res => {
          dispatch(fetchCompanyByIdSuccess(res.data));
          toastr.success(i18n.t('postAddDocumentCompanies.toastr'), i18n.t('postAddDocumentCompanies.toastr1'))
          resolve('success');
        })
        .catch(err => {
          dispatch(requestCompaniesFail(err));
          toastr.error('Erro', err.response.data.message)
          resolve('error');
        });
    })
  }
}

export const updateAddDocumentCompanies = (index, body, documentId) => {

  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestCompaniesStart());
      API.put('/companies/' + index + '/adddocument/' + documentId, body)
        .then(res => {
          dispatch(fetchCompanyByIdSuccess(res.data));
          toastr.success(i18n.t('updateAddDocumentCompanies.toastr'), i18n.t('updateAddDocumentCompanies.toastr1'))
          resolve('success');
        })
        .catch(err => {
          dispatch(requestCompaniesFail(err));
          toastr.error('Erro', err.response.data.message)
          resolve('error');
        });
    })
  }
}

export const deleteAddDocumentCompanies = (index, documentId) =>
  dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestCompaniesStart());
      API.delete('/companies/' + index + '/adddocument/' + documentId)
        .then(res => {
          dispatch(fetchCompanyByIdSuccess(res.data));
          toastr.success(i18n.t('deleteAddDocumentCompanies.toastr'), i18n.t('deleteAddDocumentCompanies.toastr1'))
          resolve('success');
        })
        .catch(err => {
          dispatch(requestCompaniesFail(err));
          toastr.error('Erro', err.response.data.message)
          resolve('error');
        });
    })
  }

  export const fetchCompaniesExport = (search, order, orderBy, emailLanguage) => {
    fetchCompaniesExport_cancel && fetchCompaniesExport_cancel();
    return dispatch => {
      return new Promise((resolve, reject) => {
        let queryParams = `?q=${search ? search : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}`;
        queryParams += `${emailLanguage && emailLanguage.length > 0 ? `&emailLanguage=${emailLanguage}` : 'pt'}`;
        API.get('/companies/export' + queryParams, {
          cancelToken: new CancelToken(function executor(c) {
            fetchCompaniesExport_cancel = c;
          })
        })
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            toastr.error('Erro', err)
            reject(err);
          });
      })
    };
  };
